(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCustomVideo = (root = document) => {
      root.querySelectorAll('[data-home-custom-video]').forEach((video) => {
        if (video.dataset.initialized === 'true') return;
        video.dataset.initialized = 'true';

        const visual = video.closest('.home-custom__visual');
        const toggle = visual?.querySelector('[data-home-custom-video-toggle]');
        const soundToggle = visual?.querySelector('[data-home-custom-sound-toggle]');
        if (!visual || !toggle || !soundToggle) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let inView = false;
        let userPaused = false;

        const updateState = () => {
          const isPlaying = !video.paused && !video.ended;
          visual.classList.toggle('is-playing', isPlaying);
          visual.classList.toggle('is-muted', video.muted);
          const playbackLabel = isPlaying ? toggle.dataset.pauseLabel : toggle.dataset.playLabel;
          const soundLabel = video.muted ? soundToggle.dataset.unmuteLabel : soundToggle.dataset.muteLabel;
          toggle.setAttribute('aria-label', playbackLabel);
          toggle.title = playbackLabel;
          soundToggle.setAttribute('aria-label', soundLabel);
          soundToggle.setAttribute('aria-pressed', String(!video.muted));
          soundToggle.title = soundLabel;
        };

        const playVideo = () => {
          const playPromise = video.play();
          if (playPromise) playPromise.then(updateState).catch(updateState);
        };

        const pauseVideo = () => {
          video.pause();
          updateState();
        };

        toggle.addEventListener('click', () => {
          if (video.paused) {
            userPaused = false;
            playVideo();
          } else {
            userPaused = true;
            pauseVideo();
          }
        });
        soundToggle.addEventListener('click', () => {
          video.muted = !video.muted;
          if (!video.muted) video.volume = 1;
          updateState();
          if (inView && !video.muted) playVideo();
        });
        video.addEventListener('play', updateState);
        video.addEventListener('pause', updateState);
        video.addEventListener('volumechange', updateState);
        updateState();

        const observer = new IntersectionObserver((entries) => {
          inView = entries[0]?.isIntersecting === true;
          if (inView && !reduceMotion && !userPaused && !document.hidden) playVideo();
          else pauseVideo();
        }, { threshold: 0.35 });
        observer.observe(video);

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) pauseVideo();
          else if (inView && !reduceMotion && !userPaused) playVideo();
        });
      });
    };

    initializeCustomVideo();
    document.addEventListener('shopify:section:load', (event) => initializeCustomVideo(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
